export default __webpack_public_path__ + "static/media/SZ07.66e2b461.mp3";